import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from "axios";
import {getCompany} from "../index";
import {BASE_URL} from "../Landing/Components/Api/Api";
import Cookies from "js-cookie";


export const getProfile = createAsyncThunk('get-profile', async () => {
    const bodyFormData = new FormData()
    bodyFormData.append('guid',Cookies.get('guid'))
    // console.log(bodyFormData.get('mob'), 'body of login')
    try{

        const response = await axios.post(BASE_URL, bodyFormData, {
            headers: {
                "Content-type": "multipart/form-data",
                'Accept': 'application/json',
                'cmd': 'updateprofile'
            },
        });
        if (response.status === 200) {
            const data = await response.data
            return data?.userinfo
        } else {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
    }catch (error){
        throw error;
    }
});



const initialState = {
    profile: [],
    loading: false,
    error: null,
};

export const ProfileSlice = createSlice({
    name: "province",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getProfile.pending, (state) => {
                state.loading = true;
            })
            .addCase(getProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.province = action.payload;
            })
            .addCase(getProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});


export default ProfileSlice.reducer;